/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

interface MenuDestination {
  addToTop: boolean;
}

interface MenuDestinationChangedAction {
  menuID: string;
  addToTop: boolean;
}

export interface SmorgStudioRecipesState {
  menuDestinations: Record<string, MenuDestination>;
}

const initialState: SmorgStudioRecipesState = {
  menuDestinations: {},
};

export const smorgStudioRecipesSlice = createSlice({
  name: 'smorgStudioRecipes',
  initialState,
  reducers: {
    menuDestinationChanged: (
      state,
      action: PayloadAction<MenuDestinationChangedAction>,
    ) => {
      const { menuID, addToTop } = action.payload;
      state.menuDestinations[menuID] ||= { addToTop };
      state.menuDestinations[menuID].addToTop = addToTop;
    },
  },
  selectors: {
    shouldAddToTopForMenuSelector: (state, menuID: string) => {
      const menuDestination = state.menuDestinations[menuID];
      if (!menuDestination) {
        return false;
      }
      return menuDestination.addToTop;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.menuDestinations = {};
    });
  },
});

export const { shouldAddToTopForMenuSelector } =
  smorgStudioRecipesSlice.selectors;

export const { menuDestinationChanged } = smorgStudioRecipesSlice.actions;

export default smorgStudioRecipesSlice.reducer;
